import { FaTachometerAlt, FaUsers, FaCalendarCheck, FaMoneyCheckAlt, FaClipboardList, FaCog } from 'react-icons/fa';

export const navLinks = [
  { to: '/dashboard', label: 'Dashboard', icon: FaTachometerAlt },
  { to: '/employees', label: 'Employees', icon: FaUsers },
  { to: '/attendance', label: 'Attendance', icon: FaCalendarCheck },
  { to: '/payroll', label: 'Payroll', icon: FaMoneyCheckAlt },
  { to: '/leaves', label: 'Leaves', icon: FaClipboardList },
  { to: '/settings', label: 'Settings', icon: FaCog },
];
